import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home-part" }
const _hoisted_2 = { class: "tab-content container py-2" }
const _hoisted_3 = {
  id: "home-part-7-tab-pane-1",
  class: "tab-pane fade show active"
}
const _hoisted_4 = { class: "row row-cols-1 row-cols-md-3 g-5" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "part-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "part-item-body" }
const _hoisted_9 = { class: "part-item-title" }
const _hoisted_10 = { class: "part-item-content" }
const _hoisted_11 = {
  id: "home-part-7-tab-pane-2",
  class: "tab-pane fade"
}
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "part-7-title" }, "产品特点", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("ul", { class: "nav nav-tabs" }, [
      _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("a", {
          href: "#home-part-7-tab-pane-1",
          "data-bs-toggle": "tab",
          role: "tab",
          class: "nav-link active"
        }, "产品特点")
      ]),
      _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("a", {
          href: "#home-part-7-tab-pane-2",
          "data-bs-toggle": "tab",
          role: "tab",
          class: "nav-link"
        }, "计算收益")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items1, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.src,
                  class: "part-item-img"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.content), 1)
                ])
              ])
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items2, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
            _createElementVNode("img", {
              class: "img",
              src: item.src
            }, null, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_15, _toDisplayString(item.content), 1)
          ]))
        }), 256))
      ])
    ])
  ]))
}